var camera, scene, renderer,
    geometry, material, mesh;
 
init();
animate(); 

function init() {
    

    clock = new THREE.Clock();

    renderer = new THREE.WebGLRenderer();
    renderer.setSize( window.innerWidth, window.innerHeight );

    scene = new THREE.Scene();
 
    camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 10000 );
    camera.position.z = 1000;
    scene.add( camera );
 
    geometry = new THREE.CubeGeometry( 200, 200, 200 );
    material = new THREE.MeshLambertMaterial( { color: 0x00575e, wireframe: false } );
    mesh = new THREE.Mesh( geometry, material );
    //scene.add( mesh );
    cubeSineDriver = 0;
 
    THREE.ImageUtils.crossOrigin = ''; //Need this to pull in crossdomain images from AWS

    light = new THREE.DirectionalLight(0xffffff,0.5);
    light.position.set(-1,0,1);
    scene.add(light);
  
    smokeTexture = THREE.ImageUtils.loadTexture('//tieliang.myshopify.com/cdn/shop/t/2/assets/Smoke-Element.png');
    smokeMaterial = new THREE.MeshLambertMaterial({color: 0x009eab, map: smokeTexture, transparent: true});
    smokeGeo = new THREE.PlaneGeometry(300,300);
    smokeParticles = [];


    for (p = 0; p < 150; p++) {
        var particle = new THREE.Mesh(smokeGeo,smokeMaterial);
        particle.position.set(Math.random()*500-250,Math.random()*500-250,Math.random()*1000-100);
        particle.rotation.z = Math.random() * 360;
        scene.add(particle);
        smokeParticles.push(particle);
    }
 // container.insertBefore(newFreeformLabel, container.firstChild);
    document.body.insertBefore( renderer.domElement, document.body.firstChild );
 
}
 
function animate() {
 
    // note: three.js includes requestAnimationFrame shim
    
    delta = clock.getDelta();
    requestAnimationFrame( animate );
    evolveSmoke();
    render();
    
}
 
function evolveSmoke() {
    var sp = smokeParticles.length;
    while(sp--) {
        smokeParticles[sp].rotation.z += (delta * 0.2);
    }
}

function render() {
 
    mesh.rotation.x += 0.005;
    mesh.rotation.y += 0.01;
    cubeSineDriver += .01;
    mesh.position.z = 100 + (Math.sin(cubeSineDriver) * 500);
    renderer.render( scene, camera );
 
}




function windowIncreased() {
  return ($(window).innerWidth() > $('canvas').width()) || ($(window).innerHeight() > $('canvas').height());
}

function reloadCanvas() {
  $('canvas').width($(window).innerWidth());
  $('canvas').height($(window).innerHeight());
}


$(window).resize(function() {
  afterResize(function() {
    if (windowIncreased()) {
      reloadCanvas();
      resetFont();
    }

    fixOverflow();

  }, 500, 'background-canvas');
});


function isOverflowing() {
  return (document.body.scrollHeight > document.body.clientHeight) || (document.body.scrollWidth > document.body.clientWidth);
}

function fixOverflow() {
  if (isOverflowing() && !fontSmallest()) {
    decrementFont();
    fixOverflow();
  }
}

function fontSmallest() {
  var fontSize = parseInt($('html').css('font-size'));

  return fontSize <= 5;
}

function decrementFont() {
  var fontSize = parseInt($('html').css('font-size'));
  $('html').css('font-size', --fontSize + 'px');
}

function resetFont() {
  $('html').css('font-size', '');
}

fixOverflow();

$(document).keypress(function(e) {
  
  if (e.ctrlKey && e.key == 'p') {
    $('#LoginModal').modal('show');
  }
});